import { Stack } from "@mui/material";
import { useMemo } from "react";

import {
  ModelCardFragment,
  ModelCardLabelFragment,
} from "../../models.graphql";
import { ModelCardIndicators } from "../ModelIndicators/ModelCardIndicators";
import { ModelCardContentCreator } from "./ModelCardContentCreator";
import { ModelCardContentLabels } from "./ModelCardContentLabels";

interface ModelCardContentProps {
  modelLabels: ModelCardLabelFragment[];
  model: ModelCardFragment;
  onClickLabel?: (event: React.MouseEvent, labelId: string) => void;
  isUserWorkspaceModel: boolean;
}

export const ModelCardContent = (props: ModelCardContentProps) => {
  const { model, modelLabels, onClickLabel, isUserWorkspaceModel } = props;

  const labels = useMemo(() => {
    let charCount = 0;
    const output: ModelCardLabelFragment[] = [];
    for (const label of modelLabels) {
      charCount += label.name.length;
      if (charCount > 24) {
        break;
      }
      output.push(label);
    }
    return output;
  }, [modelLabels]);

  const overflowCount = modelLabels.length - labels.length;

  return (
    <Stack
      direction="column"
      sx={{ position: "relative", width: "100%", gap: 2 }}
    >
      <ModelCardContentCreator model={model} />
      <ModelCardContentLabels
        labels={labels}
        onClickLabel={onClickLabel}
        overflowCount={overflowCount}
      />
      <ModelCardIndicators
        model={model}
        onClickLabel={onClickLabel}
        isUserWorkspaceModel={isUserWorkspaceModel}
      />
    </Stack>
  );
};
